export enum Routes {
  IntegrationRouter = "*",
  IntegrationSearchPageRouter = "/integration/search",
  IntegrationSettingsPageRouter = "/integration/:integrationId/settings",
}
